import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() {
  }

  /**
   * load analytics
   * @param trackingID
   */
  loadGoogleAnalytics(router: Router, trackingID: string): void {

    console.log(`---GTM Tracking ID: ${{trackingID}} --------`);

    //define dataLayer
    const gtmDataLayerScript = document.createElement('script');
    const gtmDataLayerText = `window.dataLayer = window.dataLayer || [];`;


    //define script to load gtm javascript
    const gtmFunctionScript = document.createElement('script');
    const gtmFunctionText = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':

    new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],

    j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=

    \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);

    })(window,document,\'script\',\'dataLayer\',\'${ trackingID }\');`;


    //append dataLayer and gtm script to DOM
    if (document.documentElement.firstChild) {
      console.log('-------ADDING GTM DataLayer--------------');
      gtmDataLayerScript.innerText = gtmDataLayerText;
      document.documentElement.firstChild.appendChild(gtmDataLayerScript);

      console.log('-------ADDING GTM script--------------');
      gtmFunctionScript.innerText =  gtmFunctionText;
      document.documentElement.firstChild.appendChild(gtmFunctionScript);

      //subscribe to navigation events
      this.subscribe(router);

    } else {
      console.log('-------FAILED to add GTM script--------------');
    }

  }

  /**
   * Subscribe to navigation events.
   *
   * @param router
   */
  private subscribe(router: Router) {
    // this is the snippet which make google analytics able to track page view load as i mentioned above in the introduction
    router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.pushPageView(event.url);
        }
      }
    );
  }


  public  pushPageView(pageUrl: string) {
    //console.log("------- PageView: " + pageUrl + "--------------");

    (window as any).dataLayer.push({'event': 'pageView',
      'pageURL' : pageUrl,
      'pageTitle' : pageUrl});
  }


}
